import { createBreakpoints } from '@chakra-ui/theme-tools'
import { extendTheme } from '@chakra-ui/react'

// export const breakpoints = createBreakpoints({
//   sm: '48em',
// })
export const breakpoints = createBreakpoints({ sm: '768px', md: '768px', lg: '768px', xl: '768px', '2xl': '768px' })

const spBaseWidth = 375

export const vw = (size: number, baseWidth = spBaseWidth) => {
  return `${(size / baseWidth) * 100}vw`
}

export const theme = extendTheme({
  breakpoints,
  fonts: {
    body: 'Midashi Go MB31',
  },
  fontWeights: {},
  colors: {
    about: {
      normal: '#0066FF',
      dark: '#003D99',
    },
    award: {
      normal: '#6E15FF',
      dark: '#3D00A2',
    },
    entry: {
      normal: '#FF15CB',
      dark: '#9D007A',
    },
    event: {
      normal: '#1CB918',
      dark: '#149300',
    },
    internship: {
      normal: '#FF005C',
      dark: '#AB003E',
    },
    summit: {
      normal: '#FF7A00',
      dark: '#D66700',
    },
    privacy: {
      normal: '#555555',
      dark: '#555555',
    },
    snspolicy: {
      normal: '#555555',
      dark: '#555555',
    },
  },
  sizes: {
    contentMinWPC: '1366px',
    contentMinWSP: vw(375),
    contentPC: '920px',
    contentSP: vw(345),
    content: [vw(345), '920px'],
  },
  styles: {
    global: {
      html: {
        height: '100%',
      },
      body: {
        fontFamily: 'body',
        fontFeatureSettings: 'palt',
        height: '100%',
        overscrollBehaviorY: 'none',
      },
    },
  },
  components: {
    Heading: {
      baseStyle: {
        fontFamily: 'body',
      },
    },
    Button: {
      baseStyle: {
        _focus: {
          outline: 'none',
          boxShadow: 'none',
        },
      },
    },
  },
})
